import { useMemo } from 'react';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { IssuedVouchersContent } from '@starjack/widgets/issuedVouchers';
import { VoucherToolGuard } from '@/guards/VoucherToolGuard';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useGetUsersQuery } from '@/api/v2/user';

const IssueVouchers: PageWithLayout = () => {
    const { liftOperatorData } = useAuthentication();
    const liftOperatorId = liftOperatorData?.liftOperatorId;
    const { data: users, isError } = useGetUsersQuery(
        { liftOperatorId: liftOperatorId ?? '' },
        { skip: !liftOperatorId }
    );
    // Without a loaded user list the issuer column falls back to the raw id.
    const issuerNames = useMemo(
        () =>
            users && !isError
                ? Object.fromEntries(
                      users
                          .filter((user) => user.id)
                          .map((user) => [user.id as string, user.username])
                  )
                : undefined,
        [users, isError]
    );

    return (
        <VoucherToolGuard>
            <Helmet>
                <title>Gutscheine ausstellen | Starjack Admin</title>
            </Helmet>

            <IssuedVouchersContent issuerNames={issuerNames} />
        </VoucherToolGuard>
    );
};

IssueVouchers.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

IssueVouchers.isProtected = true;

// The main account (UserType.LiftOperator) is always authorized; sub-users
// need the dedicated issue permission.
IssueVouchers.permissions = [Permission.VOUCHER_ISSUE];

export default IssueVouchers;
